import { isCzechHoliday } from "./czechHolidays";
import { parseIsoDate, toIsoDateString } from "./isoDate";
export function computeGapMarkers(issues) {
    var sorted = issues
        .filter(function (issue) { return issue.expectedDate; })
        .map(function (issue) { return ({ issue: issue, date: parseIsoDate(issue.expectedDate) }); })
        .sort(function (a, b) { return a.date.getTime() - b.date.getTime(); });
    if (sorted.length === 0)
        return [];
    var occupiedDates = new Set();
    sorted.forEach(function (entry) {
        var _a, _b, _c;
        var mergeCount = (_b = (_a = entry.issue.mergedIssueNumbers) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 1;
        if (mergeCount <= 1) {
            occupiedDates.add(toIsoDateString(entry.date));
            return;
        }
        var memberDates = (_c = entry.issue.mergedIssueDates) !== null && _c !== void 0 ? _c : [];
        if (memberDates.length > 0) {
            memberDates.forEach(function (iso) { return occupiedDates.add(iso); });
            return;
        }
        // Fallback for older backends: primary.date + (mergeCount-1) consecutive days.
        var cursor = new Date(entry.date);
        for (var dayOffset = 0; dayOffset < mergeCount; dayOffset++) {
            occupiedDates.add(toIsoDateString(cursor));
            cursor.setDate(cursor.getDate() + 1);
        }
    });
    var sortedKeys = Array.from(occupiedDates).sort();
    var start = parseIsoDate(sortedKeys[0]);
    var end = parseIsoDate(sortedKeys[sortedKeys.length - 1]);
    var markers = [];
    var cursor = new Date(start);
    while (cursor <= end) {
        var key = toIsoDateString(cursor);
        if (!occupiedDates.has(key)) {
            var dow = cursor.getDay();
            if (dow === 0) {
                markers.push({ kind: "SUNDAY", date: new Date(cursor) });
            }
            else {
                var holiday = isCzechHoliday(cursor);
                if (holiday) {
                    markers.push({
                        kind: "HOLIDAY",
                        date: new Date(cursor),
                        code: holiday.code,
                    });
                }
            }
        }
        cursor.setDate(cursor.getDate() + 1);
    }
    return markers;
}
